<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-button
                        style="padding: 0; margin: 20px"
                        type="text"
                        icon="el-icon-back"
                        @click="$router.go(-1)"
                >
                    返回
                </el-button>
            </el-col>
        </el-row>

        <el-row>
            <el-table
                    v-loading="loading"
                    :data="list"
                    border
                    size="mini"
                    :stripe="true"
                    style="width: 100%; margin: 20px 0"
            >
                <el-table-column
                        prop="id"
                        label="ID"
                        align="center"
                ></el-table-column>
                <el-table-column
                        prop="order_no"
                        label="订单号"
                        align="center"
                ></el-table-column>
                <el-table-column
                        prop="nickname"
                        label="昵称"
                        align="center"
                ></el-table-column>
                <el-table-column
                        prop="mobile_phone"
                        label="手机号"
                        align="center"
                ></el-table-column>
                <el-table-column
                        prop="status"
                        label="订单状态"
                        align="center"
                ></el-table-column>
                <el-table-column
                        prop="paid_at"
                        label="支付时间"
                        align="center"
                ></el-table-column>
                <el-table-column
                        prop="total_amount"
                        label="支付金额"
                        align="center"
                ></el-table-column>
            </el-table>
        </el-row>
        <el-row>
            <div class="block">
                <el-pagination
                        background
                        @current-change="getList"
                        :current-page.sync="query.page"
                        :page-size="query.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="total"
                >
                </el-pagination>
            </div>
        </el-row>
    </div>
</template>

<script>
    import {
        flashSaleProductOrder,
    } from "@/api/promotion";

    export default {
        data: function () {
            return {
                dialogVisible: false,
                list: [],
                loading: false,
                total: 0,
                query: {
                    id: 0,
                    page: 1,
                    limit: 15,
                },
            };
        },
        created: function () {
            this.id = this.$route.query.id;
            this.query.id = this.id;
            this.getList();
        },
        methods: {
            getList(str) {
                this.loading = true;
                flashSaleProductOrder(this.query).then((response) => {
                    this.list = response.data.list;
                    this.total = response.data.total;
                    this.loading = false;
                });
            },
        },
    };
</script>